<mat-form-field *ngIf="descriptor">
    <mat-label>{{descriptor.controlLabel}}</mat-label>
    <mat-select [formControl]="control" [multiple]="hasProperty('multiple')">
        <mat-option *ngFor="let option of options" [value]="option.key">
            {{option.value}}
        </mat-option>
    </mat-select>
    <mat-hint *ngIf="descriptor.controlHint">{{descriptor.controlHint}}</mat-hint>
    <mat-error>
        <vedrax-validation [control]="control" [validations]="descriptor.controlValidations"></vedrax-validation>
    </mat-error>
</mat-form-field>